jQuery(document).ready(function($) {

  $(document).foundation()

  // node webform scroll to form on error - workaround for ajax
  if ($('.node--type-webform [data-drupal-messages]').length > 0) {
    var webformScrollPosition = $('.node--type-webform form').offset().top - $('header').height()
    $('html, body').animate({scrollTop: webformScrollPosition }, 500)
  }

  // notification bar
  if ($('.notification-bar').length > 0) {
    if (!Cookies.get('notification-bar--has-been-shown')) {
      $('body').addClass('notification-bar--is-showing')
      Cookies.set('notification-bar--has-been-shown', '1')
    }
  }

  // search
  $('.search-results-set').each(function() {
    var $set = $(this)
    var nodeType = $set.data('set')
    $set.find('.search-result').not('[data-node-type="' + nodeType + '"]').parent().remove()
    var length = $set.find('.search-result[data-node-type="' + nodeType + '"]').length
    if (length > 0) {
      $set.removeClass('hide')
    }
  })

  // share
  $('.share .share-activator').on('click', function() {
    $(this).closest('.share').find('.share-dropdown').toggleClass('share-dropdown--is-showing')
  })

  // mobile toggle
  $('.mobile-toggle').on('click', function(e) {
    if ($('body').hasClass('main-menu--is-open')) {
      $('.main-menu').removeClass('main-menu--is-showing')
      setTimeout(function() {
        $('body').removeClass('main-menu--is-open')
      }, 100)
    } else {
      $('body').addClass('main-menu--is-open')
      setTimeout(function() {
        $('.main-menu').addClass('main-menu--is-showing')
      }, 250)
    }
    e.preventDefault()
    e.stopPropagation()
  })

  // mobile menu projects filters toggle
  $('.main-menu .projects-toggle span').on('click', function() {
    $('.projects-menu').toggleClass('projects-menu--is-open')
  })

  // headroom
  $('header').headroom({
    offset: 80
  })

  // project filters
  // do filter
  $('.filters .filter-tags a').on('click', function(e) {
    var $a = $(this)
    var tid = $a.data('term-tid')
    $('.filters-form input[value="' + tid + '"]').prop('checked', true)
    $('.filters-form').submit()
    e.preventDefault()
  })
  // remove selected filter
  $('.results-tags a').on('click', function(e) {
    var $a = $(this)
    var tid = $a.data('term-tid')
    $('.filters-form input[value="' + tid + '"]').prop('checked', false)
    $('.filters-form').submit()
    e.preventDefault()
  })

  // list projects load more
  $('.node--type-projects-index-list .load-more').on('click', function(e) {
    $('.node--type-projects-index-list .result').removeClass('hide-for-small-only')
    $('.node--type-projects-index-list .grid-container-divider').removeClass('hide-for-small-only')
    $(this).remove()
    e.preventDefault()
  })

  // list project ordering
  var orderDirection = 'desc'
  $('.node--type-projects-index-list .orders a').on('click', function(e) {
    var $a = $(this)
    var orderType = $a.data('order-type')
    if ($a.hasClass('active')) {
      orderDirection = orderDirection == 'desc' ? 'asc' : 'desc'
      $a.removeClass('asc desc').addClass(orderDirection)
    } else {
      $('.node--type-projects-index-list .orders a').removeClass('active asc desc')
      if (orderType == 'year') {
        $a.addClass('active desc')
        orderDirection = 'desc'
      } else {
        $a.addClass('active asc')
        orderDirection = 'asc'
      }
    }

    var sortOptions = {
      selector: 'p[data-' + orderType + ']',
      data: orderType,
      order: orderDirection
    }

    //console.log(sortOptions)

    tinysort('div#results>div.result-item', sortOptions);

    e.preventDefault()
  })

  // project hover show abstract
  $('.node--type-projects-index-grid .results a.box-image').hover(
    function() {
      if (Foundation.MediaQuery.current != 'small') {
        var $box = $(this)
        var textHeight = $box.find('.text-bottom').outerHeight()
        $box.find('.excerpt').css({
          top: 0 - textHeight
        })
      }
    },
    function() {
      $(this).find('.excerpt').css({
        top: 0
      })
    }
  )

  // window resize - grid projects, main height
  $(window).on('resize', function() {
    // header
    if ($('.page-node-type-homepage').length == 0) {
      var headerHeight = $('header').height()
      if (Foundation.MediaQuery.current == 'small') {
        headerHeight += 10
      }
      if ($('.page-node-type-about').length == 1) {
        headerHeight = 0
      }
      $('#main').css({
        marginTop: headerHeight
      })
    }
  }).trigger('resize')

  // grid projects load more
  $('.node--type-projects-index-grid .load-more').on('click', function(e) {
    $('.node--type-projects-index-grid .results .cell').removeClass('hide-for-small-only')
    $(this).remove()
    e.preventDefault()
  })

  // awards press load all
  $('.awards-press .load-all').on('click', function(e) {
    $('.awards-press .set').removeClass('hide')
    $('.awards-press .load-awards, .awards-press .load-press').remove()
    $(this).remove()
    e.preventDefault()
  })

  // awards load more
  $('.awards-press .load-awards').on('click', function(e) {
    $('.awards-press .set-awards').removeClass('hide')
    $(this).remove()
    e.preventDefault()
  })

  // press load more
  $('.awards-press .load-press').on('click', function(e) {
    $('.awards-press .set-press').removeClass('hide')
    $(this).remove()
    e.preventDefault()
  })

  // about person bios
  $('.team .person').on('click', function() {
    $(this).toggleClass('person--is-open')
  })

  // homepage carousel
  var $carouselHomepage = $('.carousel-homepage').flickity({
    cellSelector: '.carousel-cell',
    setGallerySize: false,
    prevNextButtons: false,
    pageDots: false,
    fade: true,
    autoPlay: 4000,
    lazyLoad: 2,
    wrapAround: true,
    pauseAutoPlayOnHover: false,
    on: {
      ready: function() {
        $('.carousel-homepage').addClass('carousel-homepage--is-showing')
      },
      select: function() {
        if ($carouselHomepage) {
          var currentIndex = $carouselHomepage.data('flickity').selectedIndex
          // update caption
          var $cell = $carouselHomepage.find('.carousel-cell').eq(currentIndex)
          $('.carousel-homepage-container .carousel-nav').find('.caption').html($cell.find('.caption').html())
        }
      }
    }
  })

  $('.carousel-homepage-container .next').on('click', function(e) {
    $carouselHomepage.flickity('stopPlayer')
    $carouselHomepage.flickity('next')
    $carouselHomepage.flickity('playPlayer')
    e.preventDefault()
  })

  $('.carousel-homepage-container .previous').on('click', function(e) {
    $carouselHomepage.flickity('stopPlayer')
    $carouselHomepage.flickity('previous')
    $carouselHomepage.flickity('playPlayer')
    e.preventDefault()
  })

  // carousel blog
  if ($('.node--type-blog').length > 0) {
    if (Foundation.MediaQuery.current == 'small') {
      $('.node--type-blog .hero-desktop').remove()
    } else {
      $('.node--type-blog .hero-mobile').remove()
    }
    $('.node--type-blog .content-body img').each(function() {
      var $img = $(this)
      var $parent = $(this).parent()
      var imageSrc = $img.attr('src')
      // add parent classes
      $parent.addClass('image-container carousel-image')
      var iconHtml = '<img src="/sites/jpda/themes/jpda/assets/img/icon-circle-plus.svg" class="icon-plus">'
      $parent.append(iconHtml)
        // description
      var $figure = $parent.closest('figure')
      var caption = ''
      if ($figure.length > 0 && $figure.find('figcaption').length > 0) {
        caption = $figure.find('figcaption').html()
      }
      // add slide
      var carouselCellHtml = '<div class="carousel-cell">'
      carouselCellHtml += '<div class="image">'
      carouselCellHtml += '<img src="' + imageSrc + '">'
      carouselCellHtml += '</div>'
      carouselCellHtml += '<div class="caption">'
      carouselCellHtml += caption
      carouselCellHtml += '</div>'
      carouselCellHtml += '</div>'
      $('.carousel-main').append(carouselCellHtml)
    })
  }

  // carousel main
  var $carouselMain = $('.carousel-main').flickity({
    cellSelector: '.carousel-cell',
    setGallerySize: false,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    draggable: false,
    on: {
      select: function() {
        if ($carouselMain) {
          var currentIndex = $carouselMain.data('flickity').selectedIndex
          // update caption
          var $cell = $carouselMain.find('.carousel-cell').eq(currentIndex)
          $('.carousel-modal .caption-target .counter .current').html(currentIndex + 1)
          $('.carousel-modal .caption-target .counter .total').html($carouselMain.find('.carousel-cell').length)
          $('.carousel-modal .caption-target .caption-text').html($cell.find('.caption').html())
          // hide next arrows
          if (currentIndex == $carouselMain.find('.carousel-cell').length - 1) {
            $('.carousel-container .next').addClass('hide')
          } else {
            $('.carousel-container .next').removeClass('hide')
          }
          // hide previous arrow
          if (currentIndex == 0) {
            $('.carousel-container .previous').addClass('hide')
          } else {
            $('.carousel-container .previous').removeClass('hide')
          }

        }
      },
      staticClick: function(event, pointer, cellElement, cellIndex) {
        if ($carouselMain) {
            $('.carousel-modal .caption-target').toggleClass('caption-target--is-showing')
        }
      },
      ready: function() {
        var total = $('.carousel-main').find('.carousel-cell').length
        $('.carousel-modal .caption-target .counter .total').html(total)
      }
    }
  })

  // override flickity so we can zoom with fingers
  $('.carousel .flickity-viewport').css({
    'touch-action': 'auto'
  })

  // carousel next slide
  $('.carousel-container .next').on('click', function(e) {
    $carouselMain.flickity('next')
    e.preventDefault()
  })

  // carousel previous slide
  $('.carousel-container .previous').on('click', function(e) {
    $carouselMain.flickity('previous')
    e.preventDefault()
  })

  // detect zoom - only ios
  // $('body').on('gesturechange gestureend', function(e) {
  //   if (e.originalEvent.scale <= 1.0) {
  //     $('.carousel-container .next, .carousel-container .previous, .carousel-modal .grid-share-close').removeClass('hide')
  //   } else if (e.originalEvent.scale > 1.0) {
  //     $('.carousel-container .next, .carousel-container .previous, .carousel-modal .grid-share-close').addClass('hide')
  //   }
  // })

  // hide next and previous if there is only one image
  if ($('.carousel-container .carousel-cell').length <= 1) {
    $('.carousel-container .next, .carousel-container .previous').addClass('hide')
  }

  var currentScrollPosition = $(window).scrollTop()

  // projects image - open carousel modal
  $('.node--type-projects').find('.image-container.carousel-image').on('click', function() {
    var windowInnerHeight = window.innerHeight
    currentScrollPosition = $(window).scrollTop()
    var index = $('.node--type-projects').find('.image-container.carousel-image').index($(this))
    $carouselMain.flickity('select', index)
    $('.carousel-modal').addClass('carousel-modal--is-showing')
    $('html, body').css({
      height: windowInnerHeight,
      overflow: 'hidden'
    })
  })

  // blog image - open carousel modal
  $('.node--type-blog').find('.image-container.carousel-image').on('click', function() {
    var windowInnerHeight = window.innerHeight
    currentScrollPosition = $(window).scrollTop()
    var index = $('.node--type-blog').find('.image-container.carousel-image').index($(this))
    $carouselMain.flickity('select', index)
    $('.carousel-modal').addClass('carousel-modal--is-showing')
    $('html, body').css({
      height: windowInnerHeight,
      overflow: 'hidden'
    })
  })

  // projects image - close carousel modal
  $('.carousel-modal .close-modal').on('click', function() {
    $('html, body').removeAttr('style')
    $('html, body').animate({scrollTop: currentScrollPosition }, 0)
    $('.carousel-modal').removeClass('carousel-modal--is-showing')
  })

  // node homepage resize background
  $(window).on('resize', function() {
    var windowInnerHeight = window.innerHeight
    $('.node--type-homepage .carousel-homepage-container').css({ height: windowInnerHeight - 8 })
  }).trigger('resize')

  // node project details resize carousel
  $(window).on('resize', function() {
    var windowInnerHeight = window.innerHeight
    $('.node--type-projects .carousel-modal').css({ height: windowInnerHeight })
  })

  // node homepage on scroll hide text on top of hero
  if ($('.node--type-homepage').length > 0) {
    $(window).on('scroll', function() {
      if ($(document).scrollTop() >= 80) {
        $('.node--type-homepage .about').addClass('about--is-hidden')
        setTimeout(function() {
          $('.node--type-homepage .about').remove()
        }, 4500)
      }
    })
  }

  // contact map
  if ($('#contact-map').length > 0) {

    function initContactMap() {
      var map = new google.maps.Map(document.getElementById("contact-map"), {
        zoom: 15,
        minZoom: 3,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControl: false,
        fullscreenControl: false,
        center: { lat: 40.702280, lng: -73.988130 },
      })

      // set style
      var mapType = new google.maps.StyledMapType([ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ])
      map.mapTypes.set('snazzyMapType', mapType)
      map.setMapTypeId('snazzyMapType')

      // add marker
      map.markers = [];
      var latlng = new google.maps.LatLng( 40.702780, -73.987130 );
      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: {
          url: '/sites/jpda/themes/jpda/assets/img/map-marker-blue.png',
          scaledSize: new window.google.maps.Size(30, 30)
        }
      });
      map.markers.push(marker);
      google.maps.event.addListener(marker, 'click', function() {
        window.open('https://goo.gl/maps/dujMWFSbsah8dqR37')
      });
    }
    initContactMap()
  }

  // map
  if ($('#map').length > 0) {

    function getIconScaleSize(markerType) {
      return markerType == 'active' ? new google.maps.Size(24, 24) : new google.maps.Size(24, 24)
    }

    function getIconSize(markerType) {
      return markerType == 'active' ? new google.maps.Size(24, 24) : new google.maps.Size(24, 24)
    }

    function getIconAnchor(markerType) {
      return markerType == 'active' ? new google.maps.Point(24, 24) : new google.maps.Point(24, 24)
    }

    function initMap() {

      var map = new google.maps.Map(document.getElementById("map"), {
        zoom: 3,
        minZoom: 3,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        center: { lat: 29.712776, lng: -74.005974 }
        // center: { lat: 29.512776, lng: -10.005974 }
      });
      // set style
      //var mapType = new google.maps.StyledMapType([{"elementType":"geometry","stylers":[{"color":"#e8e8e8"}]},{"elementType":"labels","stylers":[{"visibility":"off"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#e8e8e8"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#e8e8e8"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#f3f3f3"}]},{"featureType":"administrative.neighborhood","stylers":[{"visibility":"off"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#e8e8e8"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#f3f3f3"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e8e8e8"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#f3f3f3"}]},{"featureType":"road","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#e8e8e8"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#f3f3f3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f3f3f3"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3f3f3"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#f3f3f3"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#f3f3f3"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#e8e8e8"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#f3f3f3"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#f3f3f3"}]}])
      var mapType = new google.maps.StyledMapType([ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ])
      map.mapTypes.set('snazzyMapType', mapType)
      map.setMapTypeId('snazzyMapType')
      var pixelOffset = Foundation.MediaQuery.current == 'small' ? new google.maps.Size(145, 250) : new google.maps.Size(230, 250)
      var infoWindow = new google.maps.InfoWindow({
        pixelOffset: pixelOffset,
        content: ''
      });

      var bounds = new google.maps.LatLngBounds();
      var markers = []
      $('.projects .project').each(function() {
        var $project = $(this)
        var i = $project.index()
        var data = {
          nid: $project.data('nid'),
          title: $project.data('title'),
          lat: $project.data('latitude'),
          lng: $project.data('longitude'),
          location: $project.data('location'),
          date: $project.data('date'),
          url: $project.data('url'),
          disciplines: $project.data('disciplines'),
          typologies: $project.data('typologies'),
          image: $project.data('image')
        }
        var latlng = new google.maps.LatLng(data.lat, data.lng )
        var marker = new google.maps.Marker({
          position: latlng,
          map: map,
          data: data
        })
        var icon = {
          url: '/sites/jpda/themes/jpda/assets/img/map-marker-blue.png',
          scaledSize: getIconScaleSize('inactive'),
          origin: new google.maps.Point(0, 0),
          size: getIconSize('inactive'),
          anchor: getIconAnchor('inactive')
        }
        marker.setIcon(icon)
        marker.setOptions({
          zIndex: 1
        })
        //bounds.extend(latlng);
        markers[i] = marker
      })


      $.each(markers, function(i, marker) {
        // click
        google.maps.event.addListener(marker, 'click', function() {
          // reset marker
          $.each(markers, function(i, marker) {
            var icon = {
              url: '/sites/jpda/themes/jpda/assets/img/map-marker-blue.png',
              scaledSize: getIconScaleSize('inactive'),
              origin: new google.maps.Point(0, 0),
              size: getIconSize('inactive'),
              anchor: getIconAnchor('inactive')
            }
            marker.setIcon(icon)
            marker.setOptions({
              zIndex: 1
            })
          })
          // activate marker
          var icon = {
            url: '/sites/jpda/themes/jpda/assets/img/map-marker-blue.png',
            scaledSize: getIconScaleSize('active'),
            origin: new google.maps.Point(0, 0),
            size: getIconSize('active'),
            anchor: getIconAnchor('active')
          }
          marker.setIcon(icon)
          marker.setOptions({
            zIndex: 10
          })
          // infowindow
          var projectUrl = marker.data.url
          var projectImage = marker.data.image
          var projectTitle = marker.data.title
          var projectSubtitle = marker.data.disciplines + ', ' + marker.data.typologies  + ' • ' + marker.data.location + ' • ' + marker.data.date
          var contentString = ''
          contentString += '<div id="infowindow-wrapper">'
          contentString += '<span class="close">'
          contentString += '  <img src="/sites/jpda/themes/jpda/assets/img/icon-close.svg" alt="" class="icon-close">'
          contentString += '</span>'
          contentString += '  <a href="' + projectUrl + '">'
          contentString += '    <img src="' + projectImage + '">'
          contentString += '   <span class="title-subtitle">'
          contentString += '     <span class="title">'
          contentString +=          projectTitle
          contentString += '     </span>'
          contentString += '     <span class="subtitle">'
          contentString +=          projectSubtitle
          contentString += '     </span>'
          contentString += '    </span>'
          contentString += '  </a>'
          contentString += '</div>'
          infoWindow.setContent(contentString);
          infoWindow.open(map, marker);
        })
      })

      //map.fitBounds(bounds);

      // custom cluster icons
      var options = {
        styles: [
          {
            textColor: '#ffffff',
            width: 57,
            height: 57,
            textSize: 20,
            url: '/sites/jpda/themes/jpda/assets/img/map-cluster-background.png'
          },
          {
            textColor: '#ffffff',
            width: 57,
            height: 57,
            textSize: 20,
            url: '/sites/jpda/themes/jpda/assets/img/map-cluster-background.png'
          },
          {
            textColor: '#ffffff',
            width: 57,
            height: 57,
            textSize: 20,
            url: '/sites/jpda/themes/jpda/assets/img/map-cluster-background.png'
          },
          {
            textColor: '#ffffff',
            width: 57,
            height: 57,
            textSize: 20,
            url: '/sites/jpda/themes/jpda/assets/img/map-cluster-background.png'
          },
          {
            textColor: '#ffffff',
            width: 57,
            height: 57,
            textSize: 20,
            url: '/sites/jpda/themes/jpda/assets/img/map-cluster-background.png'
          }
        ]
      }
      var markerCluster = new MarkerClusterer(map, markers, options);

      function closeInfoWindow() {
        infoWindow.close()
      }

      // infowindow - close slideshow
      $('body').on('click', '.node--type-projects-index-map .close', function(e) {
        closeInfoWindow()
      })

      map.addListener('zoom_changed', function() {
        closeInfoWindow()
      })


    }

    initMap();

  }

  // print pdf
  $('a.print-pdf').on('click', function(e) {
    e.preventDefault()
    e.stopPropagation()
    window.print()
  })

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

});
